/**
 * 一覧が空 or フィルタ結果0件時の共通表示
 */
import { Inbox } from 'lucide-react';

export type EmptyStateProps = {
  message: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
};

export function EmptyState({ message, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="py-10 text-center flex flex-col items-center gap-2">
      <Inbox size={32} className="text-neutral-line" />
      <div className="text-sm text-neutral-text">{message}</div>
      {description && <div className="text-xs text-neutral-sub">{description}</div>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-2 px-3 py-1 rounded border border-brand-red text-brand-red text-xs hover:bg-brand-red hover:text-white transition"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
